import { render, staticRenderFns } from "./basketballCupFull_FIBAWA.vue?vue&type=template&id=b77a0268"
import script from "./basketballCupFull_FIBAWA.vue?vue&type=script&lang=js"
export * from "./basketballCupFull_FIBAWA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports